// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1daoQ","title":"BackImages_title__uQu7Q","images":"BackImages_images__Sj8HZ"};